import { render, staticRenderFns } from "./EditSchedule.vue?vue&type=template&id=10ab68b4&scoped=true"
import script from "./EditSchedule.vue?vue&type=script&lang=js"
export * from "./EditSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ab68b4",
  null
  
)

export default component.exports